//# sourceMappingURL=maintenance_mode.mjs.map
/// <reference types="./maintenance_mode.d.mts" />
import * as $maintenance from "../../data_types/data/maintenance.mjs";
import * as $remote from "../../data_types/data/remote.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None } from "../../gleam_stdlib/gleam/option.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $assoc from "../../tiamat/gleam/assoc.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class MaintenanceMode extends $CustomType {
  constructor(frozen, maintenances, input_organization, input_from, input_to) {
    super();
    this.frozen = frozen;
    this.maintenances = maintenances;
    this.input_organization = input_organization;
    this.input_from = input_from;
    this.input_to = input_to;
  }
}
export const MaintenanceMode$MaintenanceMode = (frozen, maintenances, input_organization, input_from, input_to) =>
  new MaintenanceMode(frozen,
  maintenances,
  input_organization,
  input_from,
  input_to);
export const MaintenanceMode$isMaintenanceMode = (value) =>
  value instanceof MaintenanceMode;
export const MaintenanceMode$MaintenanceMode$frozen = (value) => value.frozen;
export const MaintenanceMode$MaintenanceMode$0 = (value) => value.frozen;
export const MaintenanceMode$MaintenanceMode$maintenances = (value) =>
  value.maintenances;
export const MaintenanceMode$MaintenanceMode$1 = (value) => value.maintenances;
export const MaintenanceMode$MaintenanceMode$input_organization = (value) =>
  value.input_organization;
export const MaintenanceMode$MaintenanceMode$2 = (value) =>
  value.input_organization;
export const MaintenanceMode$MaintenanceMode$input_from = (value) =>
  value.input_from;
export const MaintenanceMode$MaintenanceMode$3 = (value) => value.input_from;
export const MaintenanceMode$MaintenanceMode$input_to = (value) =>
  value.input_to;
export const MaintenanceMode$MaintenanceMode$4 = (value) => value.input_to;

export function new$() {
  return new MaintenanceMode(
    new $remote.NotLoaded(),
    toList([]),
    new None(),
    $timestamp.system_time(),
    $timestamp.system_time(),
  );
}

export function set_maintenances(maintenance_mode, maintenances) {
  return new MaintenanceMode(
    maintenance_mode.frozen,
    maintenances,
    maintenance_mode.input_organization,
    maintenance_mode.input_from,
    maintenance_mode.input_to,
  );
}

export function set_frozen(maintenance_mode, frozen) {
  return new MaintenanceMode(
    frozen,
    maintenance_mode.maintenances,
    maintenance_mode.input_organization,
    maintenance_mode.input_from,
    maintenance_mode.input_to,
  );
}

export function set_organization_input(maintenance_mode, input_organization) {
  return new MaintenanceMode(
    maintenance_mode.frozen,
    maintenance_mode.maintenances,
    input_organization,
    maintenance_mode.input_from,
    maintenance_mode.input_to,
  );
}

export function set_from_input(maintenance_mode, input_from) {
  return new MaintenanceMode(
    maintenance_mode.frozen,
    maintenance_mode.maintenances,
    maintenance_mode.input_organization,
    input_from,
    maintenance_mode.input_to,
  );
}

export function set_to_input(maintenance_mode, input_to) {
  return new MaintenanceMode(
    maintenance_mode.frozen,
    maintenance_mode.maintenances,
    maintenance_mode.input_organization,
    maintenance_mode.input_from,
    input_to,
  );
}
